import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../../api/endpoints";
import { ReactQueryConfig } from "../../../../config/react-query-config";
import getInstance from "../../../../utils/rest";
import { MaintenanceModeConverter } from "../../../domain/converter/maintenance-mode.converter";
import { IMaintenanceMode } from "../../../domain/maintenance/maintenance-mode";
import { IMaintenanceModeModel } from "../../models/maintenance/maintenance-mode.model";
import { SharedQueryKeys } from "../shared-query-keys";

const inactiveMaintenanceMode: IMaintenanceMode = { active: false };

/**
 * A failed request is treated as inactive maintenance mode: the backend enforces the maintenance mode anyway,
 * so the UI must not lock out admins just because the status could not be fetched.
 */
export const getMaintenanceMode = async (): Promise<IMaintenanceMode> => {
  try {
    const { data } = await getInstance().get<IMaintenanceModeModel>(RestEndpoints.GetMaintenanceMode);
    return MaintenanceModeConverter.toDomain(data);
  } catch {
    return inactiveMaintenanceMode;
  }
};

export const useGetMaintenanceModeQuery = () => {
  return useQuery({
    queryKey: [SharedQueryKeys.GetMaintenanceMode],
    queryFn: () => getMaintenanceMode(),
    staleTime: ReactQueryConfig.staleTime,
  });
};
